import { combineReducers } from 'redux';

import UserReducer from './userReducer';
import UsersReducer from './usersReducer';
import ScoresReducer from './scoresReducer';
import EmployeesReducer from './employeesReducer';
import TeamsReducer from './teamsReducer';
import EditingUserReducer from './editingUserReducer';
import EditingTeamReducer from './editingTeamReducer';
import SprintReducer from './sprintReducer';
import OrganizationReducer from './organizationReducer';
import OrganizationsReducer from './organizationsReducer';
import ViewingUserReducer from './viewingUserReducer';
import SprintHistoryReducer from './sprintHistoryReducer';
import EditingGoalsReducer from './editingGoalsReducer';
import TalentEvaluationsReducer from './talentEvaluationsReducer';
import MyTeamsReducer from './myTeamsReducer';
import DealReducer from './dealReducer';
import DealsReducer from './dealsReducer';

const rootReducer = combineReducers({
  user: UserReducer,
  employees: EmployeesReducer,
  teams: TeamsReducer,
  scores: ScoresReducer,
  users: UsersReducer,//for admins
  editingUser: EditingUserReducer,
  editingTeam: EditingTeamReducer,
  sprint: SprintReducer,
  sprintHistory: SprintHistoryReducer,
  organization: OrganizationReducer,
  organizations: OrganizationsReducer,
  viewingUser: ViewingUserReducer,
  editingGoals: EditingGoalsReducer,
  talentEvaluations: TalentEvaluationsReducer,
  myTeams: MyTeamsReducer,
  deal: DealReducer,
  deals: DealsReducer,
  //...
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js